module.exports = __webpack_public_path__ + "img/homepage_2.c55ac24e.jpg";